import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './GetQuoteSection.css'; // Ensure this path is correct
import quoteImage from '../assets/imgs/quote-img.png'; // Update this path according to your image location
import '../App.css'
import {Link} from "react-router-dom";

const GetQuoteSection = () => {
    return (
        <section>
            <Container className="get-quote-section">
                <Row className="quote-row">
                    <Col lg={6} xl={6} sm={12} md={12} className="d-flex align-content-lg-end justify-content-lg-end">
                        <img src={quoteImage} className="get-quote-img" alt="Excited Girl" />
                    </Col>
                    <Col lg={6} xl={6} sm={12} md={12} className="get-quote-text">
                        <div className="d-flex flex-column justify-content-center">
                            <div className="text-center">
                                <h1 className="gt-fre-q">Get A Free Quote</h1>
                                <p className="text-justify">
                                    Get your quote with complete details of your project. We will get in touch with you very soon. When we get a custom quote from you!.
                                </p>
                            </div>
                            <Form>
                                {/*<Form.Group>*/}
                                {/*    <Form.Control as="textarea" id="get-quote-text-field" name="get-quote-field" rows="5" placeholder="Your message..."/>*/}
                                {/*</Form.Group>*/}
                                <div className="text-center mt-4">
                                    <Button variant="success" type="submit">
                                        <Link to="/quote"  className="link-text">Get Quote</Link>
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default GetQuoteSection;
